export default __webpack_public_path__ + "static/media/alena.4b74fadd.jpg";